/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";
import { Select } from "@churchofjesuschrist/eden-form-parts";
import { Icon as IconButton } from "@churchofjesuschrist/eden-buttons";
import { ListNumber as ListNumberIcon, ListBullet as ListBulletIcon, Bold as BoldIcon, Italic as ItalicIcon, TextUnderline as TextUnderlineIcon, Quote as QuoteIcon, Link as LinkIcon, Image as ImageIcon } from "@churchofjesuschrist/eden-icons";
import Row from "@churchofjesuschrist/eden-row";
import { spacing4 } from "@churchofjesuschrist/eden-style-constants";
const StyledWrapper = styled.div.withConfig({
  componentId: "sc-hkuziz-0"
})(["padding:", " 0;"], spacing4);
const iconSize = "24px";

const Controls = _ref => {
  let {
    disabled,
    availableControls,
    isInlineTypeActive,
    onInlineTypeToggle,
    isBlockTypeActive,
    onBlockTypeToggle,
    promptForLink,
    promptForImage,
    strings
  } = _ref;
  const hasBlockLevelSelect = availableControls.some(availableControl => availableControl.startsWith("heading") || availableControl === "preformatted");
  const blockLevelSelectValues = ["header-one", "header-two", "header-three", "header-four", "header-five", "header-six", "code-block"];
  const activeBlockLevelSelectValue = blockLevelSelectValues.reduce((result, blockLevelSelectValue) => {
    if (isBlockTypeActive(blockLevelSelectValue)) {
      return blockLevelSelectValue;
    }

    return result;
  }, "reset");
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(Row, {
    gapSize: "8",
    verticalAlign: "center"
  }, hasBlockLevelSelect ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    disabled: disabled,
    value: activeBlockLevelSelectValue,
    onChange: event => {
      const selectedBlockLevelSelectValue = event.target.value;
      const hasChangedSelection = selectedBlockLevelSelectValue !== activeBlockLevelSelectValue;

      if (hasChangedSelection) {
        const shouldResetBlockLevelSelectValue = selectedBlockLevelSelectValue === "reset";

        if (shouldResetBlockLevelSelectValue) {
          onBlockTypeToggle(activeBlockLevelSelectValue);
        } else {
          onBlockTypeToggle(selectedBlockLevelSelectValue);
        }
      }
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "reset"
  }, strings.paragraph), availableControls.includes("heading1") ? /*#__PURE__*/React.createElement("option", {
    value: "header-one"
  }, strings.heading1) : null, availableControls.includes("heading2") ? /*#__PURE__*/React.createElement("option", {
    value: "header-two"
  }, strings.heading2) : null, availableControls.includes("heading3") ? /*#__PURE__*/React.createElement("option", {
    value: "header-three"
  }, strings.heading3) : null, availableControls.includes("heading4") ? /*#__PURE__*/React.createElement("option", {
    value: "header-four"
  }, strings.heading4) : null, availableControls.includes("heading5") ? /*#__PURE__*/React.createElement("option", {
    value: "header-five"
  }, strings.heading5) : null, availableControls.includes("heading6") ? /*#__PURE__*/React.createElement("option", {
    value: "header-six"
  }, strings.heading6) : null, availableControls.includes("preformatted") ? /*#__PURE__*/React.createElement("option", {
    value: "code-block"
  }, strings.preformatted) : null)) : null, availableControls.includes("bold") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isInlineTypeActive("BOLD"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onInlineTypeToggle("BOLD"),
    role: "button"
  }, /*#__PURE__*/React.createElement(BoldIcon, {
    size: iconSize,
    title: strings.bold
  })) : null, availableControls.includes("italic") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isInlineTypeActive("ITALIC"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onInlineTypeToggle("ITALIC"),
    role: "button"
  }, /*#__PURE__*/React.createElement(ItalicIcon, {
    size: iconSize,
    title: strings.italic
  })) : null, availableControls.includes("underline") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isInlineTypeActive("UNDERLINE"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onInlineTypeToggle("UNDERLINE"),
    role: "button"
  }, /*#__PURE__*/React.createElement(TextUnderlineIcon, {
    size: iconSize,
    title: strings.underline
  })) : null, availableControls.includes("bulletedList") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isBlockTypeActive("unordered-list-item"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onBlockTypeToggle("unordered-list-item"),
    role: "button"
  }, /*#__PURE__*/React.createElement(ListBulletIcon, {
    size: iconSize,
    title: strings.bulletedList
  })) : null, availableControls.includes("numberedList") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isBlockTypeActive("ordered-list-item"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onBlockTypeToggle("ordered-list-item"),
    role: "button"
  }, /*#__PURE__*/React.createElement(ListNumberIcon, {
    size: iconSize,
    title: strings.numberedList
  })) : null, availableControls.includes("blockquote") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": isBlockTypeActive("blockquote"),
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: () => onBlockTypeToggle("blockquote"),
    role: "button"
  }, /*#__PURE__*/React.createElement(QuoteIcon, {
    size: iconSize,
    title: strings.blockquote
  })) : null, availableControls.includes("link") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": false,
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: promptForLink,
    role: "button"
  }, /*#__PURE__*/React.createElement(LinkIcon, {
    size: iconSize,
    title: strings.link
  })) : null, availableControls.includes("image") ? /*#__PURE__*/React.createElement(IconButton, {
    disabled: disabled,
    "aria-pressed": false,
    onMouseDown: event => event.preventDefault(),
    onTouchStart: event => event.preventDefault(),
    onClick: promptForImage,
    role: "button"
  }, /*#__PURE__*/React.createElement(ImageIcon, {
    size: iconSize,
    title: strings.image
  })) : null));
};

export default Controls;